import React from "react";
import styled from "styled-components";
import { colorFunctionalGray30, colorFunctionalGray60, colorMiscGray40, iconSizeL, } from "@rhumbix/rmbx_design_system_design_tokens";
export const GroupedSelectorGroupIconHeader = (data) => (React.createElement(HeaderContainer, null,
    React.createElement(HeaderIcon, null, data.icon),
    React.createElement(HeaderLabel, null, data.label)));
const HeaderContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 0px 8px 0px;
    margin: 0px 8x;
    border-bottom: 1px solid ${colorFunctionalGray30};
    min-width: 300px;
`;
const HeaderIcon = styled.span `
    svg {
        color: ${colorMiscGray40};
        height: ${iconSizeL};
        width: ${iconSizeL};
    }

    margin-right: 8px;
`;
const HeaderLabel = styled.span `
    color: ${colorFunctionalGray60};
    font-size: 14px;
    font-weight: 500;
    text-transform: none;
`;
export default GroupedSelectorGroupIconHeader;
